import type { ICustomSearchScenario } from '@/api/cms/searchScenario';

export const PENNY_SCENARIO_KEYWORDS = [
  '1 cent',
  '1 cent bet',
  '1 cent game',
  '1 cent beys',
  '1 cent slots',
  '1 cent spins',
  '1 c',
  '1cent',
  '1 cent games',
  '1 penny',
  '1 c games',
  '1 cent machine',
  '1 cent bets',
  'Lowest 1 cent',
  'Lowest 1 cent bets',
  'Penny slots',
  'Penny slot',
  'Penny games',
  'Penny game',
  'Penny bet',
];

export const PROVIDERS_SCENARIO_KEYWORDS = [
  'mancala',
  '1spin4',
  '1spin4win',
  'platipus',
  'platypus',
  'netgame',
  'gamzix',
];

export const PROVIDERS_SCENARIO_AU_KEYWORD = 'pragmatic';

export const WAGERING_SCENARIO_KEYWORDS = ['wagering', 'wager'];
export const WITHDRAWAL_SCENARIO_KEYWORDS = ['withdrawal', 'withdraw'];
export const PROMOCODES_SCENARIO_KEYWORDS = [
  'promo code',
  'promocode',
  'no deposit',
  'bonus code',
  'promo',
  'nodep',
  'bonuscode',
];

export const JACKPOT_SCENARIO_KEYWORD = 'jackpot master';
export const THEME_SCENARIO_KEYWORD = 'Mighty Magic';
export const THEME_SCENARIO_ID = '@magic';

export const checkIncludesKeywords = (
  searchPhrase: string,
  keywords: string[]
) =>
  keywords.some((keyword) =>
    searchPhrase.toLowerCase().includes(keyword.toLowerCase())
  );

export const findCustomSearchScenario = (
  scenarios: ICustomSearchScenario[],
  searchPhrase: string
) =>
  scenarios.find((s) =>
    s.searchKeywords
      .split(',')
      .map((k) => k.trim())
      .filter(Boolean)
      .some((keyword) => {
        const term = keyword.toLowerCase();
        const phrase = searchPhrase.toLowerCase();
        if (term.endsWith('*')) {
          return phrase.startsWith(term.slice(0, -1));
        }
        return phrase.includes(term);
      })
  );
